import { createContext } from 'react';
import { accordionDefaultProps } from '@gs-ux-uitoolkit-common/accordion';

export const AccordionContext = createContext({
    size: accordionDefaultProps.size,
    emphasis: accordionDefaultProps.emphasis,
});
